import { render, staticRenderFns } from "./ProxyDialog.vue?vue&type=template&id=c8b83196&"
import script from "./ProxyDialog.vue?vue&type=script&lang=js&"
export * from "./ProxyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports